//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
import { queryLiveVideo } from '@/api/api';
import IwsVideo from '@comp/VideoPlay/IwsVideo';
export default {
  name: 'waterData',
  data: function data() {
    return {
      siteId: '',
      videoList: []
    };
  },
  mixins: [GetSiteIdMixin],
  watch: {
    currentSiteId: function currentSiteId(value) {
      var ids = this.getTreeCurrentId();

      if (ids[0] == '1') {
        this.siteId = ids[1];
        this.getVideoList(ids[1]);
      }
    }
  },
  components: {
    IwsVideo: IwsVideo
  },
  created: function created() {},
  methods: {
    getVideoList: function getVideoList(id) {
      var that = this;
      queryLiveVideo({
        siteId: id,
        pageSize: 100000
      }).then(function (res) {
        if (res.success) {
          that.videoList = res.result.records;
        }
      });
    }
  }
};